import { 
    createSlice, 
    createAsyncThunk,  
    createEntityAdapter,
    createSelector,  
} from '@reduxjs/toolkit'
import { Pager } from '../../../lib/js-apiclient/src/response/Pager';
import { FarfetchModel } from '../models/farfetch/FarfetchModel';


const farfetchBrandAdapter = createEntityAdapter({})

export const farfetchBrandApi = {
    _model: null,
    _getToken: (thunkAPI) => {
        return thunkAPI.getState().identityReducer.token.signature;
    },
    fetchAll: createAsyncThunk(
        'farfetch/brand/fetchAll', 
        async ({channelId, page, term}, thunkAPI) => {
            try {
                const token = farfetchBrandApi._getToken(thunkAPI);
                const farfetchModel = new FarfetchModel(token, channelId);

                /** @type {Pager} */
                const pager = await farfetchModel.getBrands(page, term);
                
                return {
                    hasPrevPage: pager.hasPrevPage,
                    hasNextPage: pager.hasNextPage,
                    entities: pager.getEntities()
                }
            } catch (apiError) {
                return thunkAPI.rejectWithValue(apiError.toJson());
            }
        }
    ),
}

const farfetchBrandSlice = createSlice({
    name: "farfetch/brand",
    initialState: farfetchBrandAdapter.getInitialState({
        status: 'idle',
        error: null,
        showMore: true,
    }),
    reducers: {
        clearBrandList(state, action) {
            farfetchBrandAdapter.removeAll(state);
        },
    },
    extraReducers: {
        [farfetchBrandApi.fetchAll.fulfilled]: (state, action) => {
            state.status = 'farfetch/brand/fetchAll/succeeded'

            if(action.payload.hasPrevPage) {
                farfetchBrandAdapter.addMany(state, action.payload.entities)
            } else {
                farfetchBrandAdapter.setAll(state, action.payload.entities)
            }

            state.showMore = action.payload.hasNextPage;
            state.error = null;
        },
        [farfetchBrandApi.fetchAll.rejected]: (state, action) => {
            state.status = 'farfetch/brand/fetchAll/rejected'
            state.error = action.payload
        },
    }
});

export const selectFarfetchBrands = createSelector(
    (state, _) => selectAllFarfetchBrands(state),
    (_, filter) => filter,
    (items, filter) => {
        return (filter !== undefined && filter !== null && filter !== null) 
            ? items.filter((item) => {
                return item.name.startsWith(filter);
              })
            : items
    }
  );

export const {
    selectAll: selectAllFarfetchBrands,
} = farfetchBrandAdapter.getSelectors((state) => state.farfetchBrandReducer)

export const { clearBrandList } = farfetchBrandSlice.actions;

export default farfetchBrandSlice.reducer;
